export const Urls = {
    GetList: "list",
    SaveList: "list",
    DeleteList: "list/delete",
    GetAvailableLists: "list/getAvailableLists",
    GetListItem: "list/getListItem",
    GetCustomerLists: "list/GetCustomerLists",
    GetBusinessUnitLists: "list/GetBusinessUnitLists",
    GetListAlert: "list/getListAlert",
    SaveListItem: "list/saveListItem",
    SaveListAlert: "list/saveListAlert",
    DeleteListItem: "list/deleteListItem",
    DeleteListAlert: "list/deleteListAlert",
    ExportList: "list/export",
};
